import { useState } from 'react';

const FONT = "'DM Sans', sans-serif";

const PERGUNTAS = [
  {
    q: 'Quanto tempo leva pra receber a música?',
    a: '30 minutos após a confirmação do pagamento. PIX e cartão são instantâneos; boleto leva 1 a 2 dias úteis para compensar.',
  },
  {
    q: 'E se eu não gostar da música?',
    a: 'A gente refaz quantas vezes for preciso, sem custo. Se ainda assim não ficar bom, devolvemos seu dinheiro.',
  },
  {
    q: 'Posso pedir alguém da minha família para pagar?',
    a: 'Claro! Use o botão "Pedir para alguém pagar" no rodapé da página. O link funciona em qualquer celular e pode ser enviado para o WhatsApp de quem vai fazer o pagamento.',
  },
  {
    q: 'Os meus dados estão seguros?',
    a: 'Sim. O pagamento é processado pela Asaas, autorizada pelo Banco Central (código 461). Não armazenamos dados de cartão.',
  },
  {
    q: 'Posso pagar de outro jeito?',
    a: 'Trabalhamos com PIX, cartão de crédito, débito e boleto. Por enquanto, esses são os métodos disponíveis.',
  },
];

export default function FAQ() {
  const [aberta, setAberta] = useState<number | null>(null);
  return (
    <div style={{ marginTop: 18, fontFamily: FONT }}>
      <h3 style={{ fontSize: 16, fontWeight: 800, color: 'var(--heading-ink)', marginBottom: 8, letterSpacing: '-0.02em' }}>
        Perguntas frequentes
      </h3>
      {PERGUNTAS.map((p, i) => {
        const open = aberta === i;
        return (
          <div key={i} style={{
            background: 'var(--surface-white)', border: '1px solid var(--border-soft)',
            borderRadius: 12, marginBottom: 8, overflow: 'hidden',
          }}>
            <button
              type="button"
              onClick={() => setAberta(open ? null : i)}
              style={{
                width: '100%', padding: '14px 16px', textAlign: 'left',
                background: 'transparent', border: 'none', cursor: 'pointer',
                fontSize: 14, fontWeight: 600, color: 'var(--text-strong)', fontFamily: FONT,
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12,
              }}
            >
              <span>{p.q}</span>
              <span style={{ color: 'var(--text-muted)', fontSize: 18, flexShrink: 0 }}>{open ? '−' : '+'}</span>
            </button>
            {open && (
              <div style={{
                padding: '0 16px 14px', fontSize: 14, color: 'var(--text-muted)',
                lineHeight: 1.6,
              }}>{p.a}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
